import styled, { css } from 'styled-components';

import { crFont11, crFont9 } from '@controlrooms/web/src/app/global-styles';

export const DropdownRootStyled = styled.div`
  position: relative;
  display: inline-block;
`;

export const DropdownTriggerStyled = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  padding: 10px;
  svg {
    path: ${({ theme }) => theme.dropdown.optionTextColor};
  }
`;

export const DropdownOptionsStyled = styled.div<{
  position?: 'left' | 'right';
  open?: boolean;
  width?: string;
}>`
  background: ${({ theme }) => theme.dropdown.optionBackgroundColor};
  position: absolute;
  top: 100%;
  display: none;
  min-width: 120px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 1000;
  margin-top: 4px;
  ${({ position }) =>
    position === 'right'
      ? css`
          right: 0;
        `
      : css`
          left: 0;
        `}
  ${({ open }) =>
    open &&
    css`
      display: block;
    `}
  ${({ width }) =>
    width &&
    css`
      width: ${width};
    `}
`;

export const DropdownTitleStyled = styled.div`
  color: ${({ theme }) => theme.dropdown.titleTextColor};
  ${crFont9}
  padding: 6px 9px;
  text-align: left;
  cursor: pointer;
`;

export const DropdownItemStyled = styled.div<{ disabled?: boolean; active?: boolean }>`
  color: ${({ theme }) => theme.dropdown.optionTextColor};
  ${crFont11}
  padding: 6px 9px;
  text-align: left;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  text-transform: none;
  .submenu {
    display: none;
  }
  &:hover {
    background: ${({ theme }) => theme.sidebar.folders.hover.backgroundGradient};
    ${(props) => {
      if (props.disabled) {
        return `
        background: none;
        `;
      }
    }}
    .submenu {
      display: block;
    }
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    `}
  ${({ active }) =>
    active &&
    css`
      background: ${({ theme }) => theme.sidebar.folders.hover.backgroundGradient};
    `}
`;

export const DropdownSeparatorStyled = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.dropdown.dividerColor};
  margin: 4px 0;
`;
